export const asyncRouterMap = {
  userInfo: () => import("@/views/user/userInfo/index"),
  userAssess: () => import("@/views/user/userAssess/index"),
  userAssessYongyou: () => import("@/views/user/userAssessYongyou/index"),
  userCertificate: () => import("@/views/user/userCertificate/index"),
  projectInfo: () => import("@/views/project/index"),
  examList: () => import("@/views/exam/ExamList"),
  examStatistics: () => import("@/views/exam/statistics"),
  importUserAccount: () => import("@/views/importUserAccount/index"),
  agentInfo: () => import("@/views/agent/index"),
  orderInfo: () => import("@/views/order/index"),
  signUpExam: () => import("@/views/signUp/signUpExam"),
  hd1: () => import("@/views/activityStatistics/hd1"),
  hd2: () => import("@/views/activityStatistics/hd2"),
  hd2e: () => import("@/views/activityStatistics/hd2e"),
  hd3: () => import("@/views/activityStatistics/hd3"),
  hd3e: () => import("@/views/activityStatistics/hd3e"),
  examAgentListHd3e: () => import("@/views/activityStatistics/ExamAgentListHd3e"),
  examStatisticsIndex: () => import("@/views/examStatistics/index"),
  examStatisticsDetail: () => import("@/views/examStatistics/detail"),
};
